import React, { Component } from 'react'
import '../styles/VeryBadNight.css'
import PopIn from './PopIn'
import VBNCustom1 from '../images/Themes/VBN/vbn-custom-1.png'
import VBNCustom2 from '../images/Themes/VBN/vbn-custom-2.png'
import VBNCustom3 from '../images/Themes/VBN/vbn-custom-3.png'
import { injectIntl, defineMessages } from "react-intl"

class PopInVBNCustom extends Component {

  render() {
    const {intl:{formatMessage}} = this.props
    return (
      <PopIn
        closePopIn={() => this.props.closePopIn()}
        title={formatMessage(messages.title)}
      >
        <p className="pop-in-baseline">{formatMessage(messages.baseline)}</p>
        <div className="pop-in-content">
          <h4>{formatMessage(messages.contentTitle)}</h4>
          <p>- {formatMessage(messages.content1)}</p>
          <p>- {formatMessage(messages.content2)}</p>
          <p>- {formatMessage(messages.content3)}</p>
          <p>{formatMessage(messages.content4)}</p>
          <div className="pop-in-custom-container">
          <p className="pop-in-custom-label">{formatMessage(messages.idealFor)}</p>
            <div className="pop-in-custom-card">
              <div
                className="pop-in-custom-icon"
                style={{backgroundImage: `url(${VBNCustom1})`}}
                ></div>
              <div className="pop-in-custom-text">{formatMessage(messages.idealForContent1)}</div>
            </div>
            <div className="pop-in-custom-card">
              <div
                className="pop-in-custom-icon"
                style={{backgroundImage: `url(${VBNCustom2})`}}
                ></div>
              <div className="pop-in-custom-text">{formatMessage(messages.idealForContent2)}</div>
            </div>
            <div className="pop-in-custom-card">
              <div
                className="pop-in-custom-icon"
                style={{backgroundImage: `url(${VBNCustom3})`}}
                ></div>
              <div className="pop-in-custom-text">{formatMessage(messages.idealForContent3)}</div>
            </div>
          </div>
        </div>
        <div className="pop-in-footer">
          <p>{formatMessage(messages.footer)}</p>
        </div>
      </PopIn>
    )
  }
}

const messages = defineMessages({
  title: {
    id: 'popinVBNCustom.title',
    defaultMessage: 'Option de personnalisation'
  },
  baseline: {
    id: 'popinVBNCustom.baseline',
    defaultMessage: 'Pour 50€ en plus de votre session de jeu.'
  },
  contentTitle: {
    id: 'popinVBNCustom.contentTitle',
    defaultMessage: 'Voici ce que nous vous proposons :'
  },
  content1: {
    id: 'popinVBNCustom.content1',
    defaultMessage: "Création d'un gâteau sur mesure"
  },
  content2: {
    id: 'popinVBNCustom.content2',
    defaultMessage: "Personnalisation d'une énigme pour la personne sélectionnée"
  },
  content3: {
    id: 'popinVBNCustom.content3',
    defaultMessage: "Personnalisation de l'ambiance (playlist personnalisée...)"
  },
  content4: {
    id: 'popinVBNCustom.content4',
    defaultMessage: "Pour cela il nous vous enverrons un petit questionnnaire dans lequel vous devrez nous donner plus d’infos sur la personne concernée :  son nom / surnom, des photos embarassantes ou non, sa playlist etc…"
  },
  idealFor: {
    id: 'popinVBNCustom.idealFor',
    defaultMessage: "Idéal pour :"
  },
  idealForContent1: {
    id: 'popinVBNCustom.idealForContent1',
    defaultMessage: "Anniversaires"
  },
  idealForContent2: {
    id: 'popinVBNCustom.idealForContent2',
    defaultMessage: "EVG / EFG"
  },
  idealForContent3: {
    id: 'popinVBNCustom.idealForContent3',
    defaultMessage: "Un peu de piment :)"
  },
  footer: {
    id: 'popinVBNCustom.footer',
    defaultMessage: "Pour profiter de cette option, rendez-vous dans votre réservation Very Bad Night !"
  },
})

export default injectIntl(PopInVBNCustom)



// WEBPACK FOOTER //
// ./src/components/PopInVBNCustom.js